// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1bQyu","options":"AnswerScale_options__2B0fO","selected":"AnswerScale_selected__1Mnbu"};